import { combineTokens } from '@utils/css';

const tokens = combineTokens("--dropzone-with-tile", {
  left: "0%",
  top: "0%",
  width: "0%",
  height: "0%"
});
const dropzone = "_35sdt2awec";
const dropzoneTile = "_35sdy68r8a";

export { dropzone, dropzoneTile, tokens };
import "./atom.with-tile.style.linaria.module.css";
//# sourceMappingURL=atom.with-tile.style.js.map
